import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OrganizationSetting from "@/services/organization/organization-setting";
import { UpdateDialerRotationSetting } from "@/dtos/OrganizationSetting.dto";

export function useUpdateDialerRotationSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (settings: UpdateDialerRotationSetting) => {
      const result = await OrganizationSetting.updateDialerRotationSetting(settings);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update dialer rotation setting");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dialerRotationSetting"] });
    },
  });
}
